export const normalizeUrl = url =>
  url && url.replace(/http:\/\/|https:\/\/|\/$/g, '');



// WEBPACK FOOTER //
// ./src/services/string-utils.js